module.exports = __webpack_public_path__ + "img/stock3.00164c17.png";